import { render, staticRenderFns } from "./foodLog.vue?vue&type=template&id=305028fd&scoped=true"
import script from "./foodLog.vue?vue&type=script&lang=js"
export * from "./foodLog.vue?vue&type=script&lang=js"
import style0 from "./foodLog.vue?vue&type=style&index=0&id=305028fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305028fd",
  null
  
)

export default component.exports